const users = {
    name: 'Users/UsersPage',
    path: '/users',
    icon: 'mdi-account-group',
    label: 'Users'
};

const profile = {
    name: 'Dashboard/UserProfilePage',
    path: '/profile',
    icon: 'mdi-account',
    label: 'Profile'
};

const horizon = {
    name: 'Horizon',
    path: '/horizon',
    icon: 'mdi-sun-angle',
    label: 'Horizon',
    private: true,
    privateLabel: 'SA'
};

const pulse = {
    name: 'Pulse',
    path: '/pulse',
    icon: 'mdi-pulse',
    label: 'Pulse',
    private: true,
    privateLabel: 'SA'
};

const telescope = {
    name: 'Telescope',
    path: '/telescope',
    icon: 'mdi-telescope',
    label: 'Telescope',
    private: true,
    privateLabel: 'SA'
};

const labs = {
    name: 'Labs',
    path: '/labs',
    icon: 'mdi-flask',
    label: 'Labs',
};

const pharmacies = {
    name: 'Pharmacies',
    path: '/pharmacies',
    icon: 'mdi-pill',
    label: 'Pharmacies'
};

const compounds = {
    name: 'Compounds',
    path: '/compounds',
    icon: 'mdi-application-array-outline',
    label: 'Compounds'
};

const products = {
    name: 'Products',
    path: '/products',
    icon: 'mdi-package-variant-closed',
    label: 'Products'
};

const orders = {
    name: 'Orders',
    path: '/orders',
    icon: 'mdi-cart',
    label: 'Orders'
};

const pricing = {
    name: 'Pricing',
    path: '/pricing',
    icon: 'mdi-currency-usd',
    label: 'Pricing'
};

const labProfile = {
    name: 'Lab Profile',
    path: '/lab-profile',
    icon: 'mdi-flask',
    label: 'Lab Profile'
};

const pharmacyProfile = {
    name: 'Pharmacy Profile',
    path: '/pharmacy-profile',
    icon: 'mdi-pill',
    label: 'Pharmacy Profile'
};

export const superAdmin = _ => {
    return [
        labs,
        users
    ];
};

export const systemAdmin = _ => {
    return [
        labs,
        users
    ];
};

export const labAdmin = _ => {
    return [
        orders,
        products,
        compounds,
        pharmacies,
        users,
        pricing,
        labProfile
    ];
};

export const labStaff = _ => {
    return [
        orders,
        products,
        compounds,
        pharmacies
    ];
};

export const accessingLab = _ => {
    return [
        orders,
        products,
        compounds,
        pharmacies,
        users,
        pricing,
        labProfile
    ];
};

export const pharmacyAdmin = _ => {
    return [
        orders,
        users,
        pharmacyProfile
    ];
};

export const pharmacyStaff = _ => {
    return [
        orders
    ];
};

export const accessingPharmacy = _ => {
    return [
        orders,
        users,
        pharmacyProfile
    ];
};

export const bottomNavRoutes = _ => {
    return [
        profile,
        horizon,
        pulse,
        telescope,
    ];
};
